// extracted by mini-css-extract-plugin
module.exports = {"container":"TabSwitchSkeleton_container__20rJz"};